import { Loader2 } from "lucide-react";

interface LoaderProps {
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "default" | "overlay" | "inline";
  text?: string;
  className?: string;
}

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-8 w-8",
  lg: "h-12 w-12",
  xl: "h-16 w-16",
};

const textSizeClasses = {
  sm: "text-xs",
  md: "text-sm",
  lg: "text-base",
  xl: "text-lg",
};

export const Loader = ({ 
  size = "md", 
  variant = "default", 
  text,
  className 
}: LoaderProps) => {
  if (variant === "overlay") {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
        <div className="flex flex-col items-center gap-6 bg-white p-8 rounded-2xl shadow-2xl border border-gray-200">
          <div className="relative">
            <div className="absolute inset-0 bg-blue-500/20 rounded-full blur-xl animate-pulse"></div>
            <Loader2 
              className={`animate-spin text-blue-600 relative ${sizeClasses[size]} ${className || ''}`.trim()}
            />
          </div>
          {text && (
            <p className={`font-semibold text-gray-800 ${textSizeClasses[size]}`.trim()}>
              {text}
            </p>
          )}
        </div>
      </div>
    );
  }

  if (variant === "inline") {
    return (
      <div className="flex items-center gap-2">
        <Loader2 
          className={`animate-spin text-blue-600 ${sizeClasses[size]} ${className || ''}`.trim()}
        />
        {text && (
          <span className={`text-gray-600 ${textSizeClasses[size]}`.trim()}>
            {text}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-8">
      <Loader2 
        className={`animate-spin text-blue-600 ${sizeClasses[size]} ${className || ''}`.trim()} 
      />
      {text && (
        <p className={`font-medium text-gray-600 ${textSizeClasses[size]}`.trim()}>
          {text}
        </p>
      )}
    </div>
  );
};

// Spinner-only variant for minimal use
export const Spinner = ({ 
  size = "md", 
  className 
}: Pick<LoaderProps, "size" | "className">) => {
  return (
    <Loader2 
      className={`animate-spin text-blue-600 ${sizeClasses[size]} ${className || ''}`.trim()} 
    />
  );
};